import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'
import Tabs from '../../../common/Tabs'
import { aiTabs } from '../shared/aiTabs';

const LLMModels = (props) => {
    const data = {
        url: '/admin/ai/llm-models',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: '/ai/llm-models/{id}',
        userfilter:[
            {
                source: 'search',
                label: 'Search',
                type: 'text',
                default: '',
            },
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Provider',
                source: 'provider',
                type: 'text',
                editable: false,
                default: '',
            },
            {
                label: 'Model',
                source: 'model',
                type: 'text',
                editable: false,
                default: '',
            },
            {
                label: 'Capabilities',
                source: 'capabilities',
                type: 'text',
                editable: false,
                default: '',
            },
            {
                label: 'Cost',
                source: 'cost',
                type: 'number',
                editable: false,
                default: 0,
            },
            {
                label: 'Enabled',
                source: 'enabled',
                type: 'boolean',
                editable: false,
                default: true,
                values: {
                    true: 'YES',
                    false: 'NO'
                },
                classnames: {
                    true: 'label label-success',
                    false: 'label label-danger'
                }
            },
            {
                label: 'Delete',
                type: 'delete',
            }
        ]
    }

    return (
        <Panel title="LLM Models">
            <>            
                <Tabs tabs={aiTabs} />
                <DataResource
                    addButtonText="Create New LLM Model"
                    addButtonType="link"
                    addButtonLink="/ai/llm-models/create"
                    data={data}
                    {...props}
                />
            </>
        </Panel>
    )
}

export default LLMModels;

